import { render, staticRenderFns } from "./JournalLinkPanel.vue?vue&type=template&id=2ba160e0"
import script from "./JournalLinkPanel.vue?vue&type=script&lang=js"
export * from "./JournalLinkPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports